import React, { useEffect, useState } from "react";
import Header from "./Header";
import Main from "./Main.jsx";
import Api from "./Api";
import { BASE_API_URL } from "./const";

const AppWrapper = () => {
  const [responseFilter, setResponseFilter] = useState();
  const [responseListChannels, setResponseListChannels] = useState();
  const [responseFilmList, setResponseFilmList] = useState();
  const [sendDataFilmList, setSendDataFilmList] = useState();
  const [sendDataFilmListQueryFilter, setSendDataFilmListQueryFilter] =
    useState("");

  useEffect(() => {
    // getDataFilter();
    // getDataListChannels();
    // getDataFilmList(1);
  }, []);

  useEffect(() => {
    getDataFilmList(1);
  }, [sendDataFilmListQueryFilter]);

  async function getDataFilter() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/listFilter`);
      setResponseFilter(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  async function getDataListChannels() {
    try {
      const response = await Api.get(`${BASE_API_URL}/api/channel/list`);
      setResponseListChannels(response.data.data);
    } catch (error) {
      console.error(error);
    }
  }
  async function getDataFilmList(numberPage) {
    Api.post(
      `${BASE_API_URL}/api/filter?page=${numberPage}${sendDataFilmListQueryFilter}`,
      sendDataFilmList
    )
      .then((response) => {
        console.log("transfer ok");
        setResponseFilmList(response);
      })
      .catch((error) => {
        console.log("transfer bad");
      });
  }
  return (
    <>
      <Header />
      {/* <Title /> */}
      {responseFilmList && (
        <Main
          responseFilmList={responseFilmList}
          setResponseListChannels={setResponseListChannels}
          setSendDataFilmListQueryFilter={setSendDataFilmListQueryFilter}
          getDataFilmList={getDataFilmList}
        />
      )}
    </>
  );
};

export default AppWrapper;
